import { basePathInit } from '@/envConst';

export default (Vue) => {

    const http = Vue.prototype.$http;

    const basePath = basePathInit();

    var service = {
      getDemoList(params) {
        return http({
          baseDomain: basePath.bossapi.system,
          url: 'ajax/userHomeComponents/businessVolumeProportion.do',
          method: 'get',
          params
        });
      },
      getPermissionTree(data) {
        return http({
          baseDomain: basePath.bossapi.system,
          url: '/web/permission/queryPermissionTree.do',
          method: 'post',
          data
        });
      }
    };
    return service; 
};